// ClimatologyWindSpeedForm.jsx
import { useState } from "react"
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Frame for Climatology Windspeed inputs
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function ClimatologyWindSpeedForm({model, setModel, fullModel}) {
  const [objsIndexes] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
  const [months] = useState(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])
  const [windSpeedSource, setWindSpeedSource] = useState(fullModel.TEMPERATURE.WINDSPEED?fullModel.TEMPERATURE.WINDSPEED.Type:'MONTHLY')

  const handleChangeWindSpeedSource = (val) => {
    setWindSpeedSource(val)

    let WINDSPEED = model.TEMPERATURE.WINDSPEED

    if(model){
      if(val==='FILE'){
        delete WINDSPEED.AWS

        WINDSPEED.Type = 'FILE'
      }
      if(val==='MONTHLY'){
        WINDSPEED.AWS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        WINDSPEED.Type = 'MONTHLY'
      }

      setModel(prev => ({
        ...prev,
        TEMPERATURE: {
          ...prev.TEMPERATURE,
          WINDSPEED: WINDSPEED
        }
      }))
    }
  }
  
  const updateMonthlyWindSpeed = (val, index) => {
    let WINDSPEED = model.TEMPERATURE.WINDSPEED 
    WINDSPEED.AWS[index] = val
    // Don't let any undefined updates go through.
    if(val === undefined) val = ""
    if(model && model.EVAPORATION){
      setModel(prev => ({
        ...prev,
        TEMPERATURE: {
          WINDSPEED: WINDSPEED,
        }
      }))
    }
  }

  return(
    <>
    {
      model.TEMPERATURE &&
      model.TEMPERATURE.WINDSPEED &&
      <>
      {(
        <div>
          <div style={{borderBottom:'3px solid #fff', paddingTop: '5px'}}>Source of Temperature Data</div>
          <label className='editor-small' >
            <input
              type="radio"
              checked={windSpeedSource === 'FILE'}
              onChange={()=>handleChangeWindSpeedSource('FILE')}
            />Use Climate File Data (see Temperature Page)
          </label>
          <label className='editor-small' >
            <input
              type="radio"
              checked={windSpeedSource === 'MONTHLY'}
              onChange={()=>handleChangeWindSpeedSource('MONTHLY')}
              />Use Monthly Averages
          </label>
          {
            model.TEMPERATURE &&
            model.TEMPERATURE.WINDSPEED &&
            model.TEMPERATURE.WINDSPEED.Type === 'MONTHLY' &&
            model.TEMPERATURE.WINDSPEED.AWS &&
            <>
            <label className='editor-small' style={{paddingTop: '15px'}}>Monthly Evaporation per day:</label>
            <Grid container>
              {
                objsIndexes.slice(0, 6).map(v=>
                  <Grid item xs={2} padding={1} key={'ClimatologyMonthlyWindSpeed'+v.toString()}>
                    <label className='editor-small' >{months[v]}
                      <input  type = "number"
                              style={{width: '95%', display: 'flex'}}
                              onChange={(e)=>{updateMonthlyWindSpeed(e.target.value, v)}}
                              value={model.TEMPERATURE.WINDSPEED.AWS[v]}
                              id={'ClimatologyMonthlyWindSpeed'+v.toString()}
                      />
                    </label>
                  </Grid>
                )
              }
            </Grid>
            <Grid container>
              {
                objsIndexes.slice(6, 12).map(v=>
                  <Grid item xs={2} padding={1} key={'ClimatologyMonthlyWindSpeed'+v.toString()}>
                    <label className='editor-small' >{months[v]}
                      <input  type = "number"
                              style={{width: '95%', display: 'flex'}}
                              onChange={(e)=>{updateMonthlyWindSpeed(e.target.value, v)}}
                              value={model.TEMPERATURE.WINDSPEED.AWS[v]}
                              id={'ClimatologyMonthlyWindSpeed'+v.toString()}
                      />
                    </label>
                  </Grid>
                )
              }
            </Grid>
            </>
          }
          </div>
        )}
      </>
    }
    </>
  )
}